import { DisciplinaCertificacaoVinculada } from 'src/paginas/parceiro-certificacao/turmas/cadastro/tipos'

export enum SituacaoTurmaCertificacao {
  Aberta = 'Aberta',
  AguardandoInicio = 'AguardandoInicio',
  Emandamento = 'Emandamento',
  Cancelada = 'Cancelada',
  Finalizada = 'Finalizada'
}

export enum TipoTurmaCertificacao {
  Aberta = 'Aberta',
  Fechada = 'Fechada'
}

export interface DadosPesquisaTurmaCertificacao {
  nome: string
  status: SituacaoTurmaCertificacao
  tipo: TipoTurmaCertificacao
  usuarioPerfilFiltro: string
  dataCriacaoTurma: string
}

export enum OpcoesBool {
  Sim = 'Sim',
  Nao = 'Nao'
}

export enum TipoCertificado {
  Fisico = 'Fisico',
  Digital = 'Digital'
}

export enum DivisaoTurmaCertificacao {
  Modulo = 'Modulo',
  Disciplina = 'Disciplina'
}

export interface ModuloTurmaCertificacao {
  id: string
  nome: string
  ordem: number
  disciplinasMCertificacao: DisciplinaCertificacaoVinculada[]
}

export interface DisciplinaTurmaCertificacao {
  id: string
  nome: string
  cargaHoraria: number
  deletado: boolean
  professorDisciplinasCertificacao?: {
    idProfessor: string
    nomeProfessor: string
    disciplinaCertificacaoId: string | null
    disciplinaModuloCertificacaoId: string | null
    nomeDisciplina: string
  }[]
  professorDisciplinasModuloCertificacao?: {
    idProfessor: string
    nomeProfessor: string
    disciplinaCertificacaoId: string | null
    disciplinaModuloCertificacaoId: string | null
    nomeDisciplina: string
  }[]
}

export interface DisciplinaSelecionada {
  id: string
  nome: string
  cargaHoraria: string
  professor: string
}
